export default "__VITE_ASSET__CnmF68Rs__"